import * as E from "~/renderer/web-components/element";

export class Badge extends E.SFMLCullingElement {
  private holderElement: HTMLElement | null = null;

  static observedAttributes = ["url"];

  public get url(): string | null {
    const url = this.getAttribute("url");
    return url;
  }

  public get hpos(): string | null {
    const hpos = this.getAttribute("hpos");
    return hpos;
  }

  public get vpos(): string | null {
    const vpos = this.getAttribute("vpos");
    return vpos;
  }

  constructor() {
    super();
  }

  public handleVisible() {
    super.handleVisible();
    this.render();
  }

  protected handleHidden() {
    super.handleHidden();
    this.unrender();
  }

  private render() {
    if (!this.url || !this.hpos || !this.vpos) return;

    this.holderElement = document.createElement("img");
    this.holderElement.setAttribute("src", this.url);
    this.holderElement.style.height = "100%";
    this.holderElement.style.width = "100%";

    this.appendChild(this.holderElement);
  }

  private unrender() {
    if (this.holderElement) {
      const parentNode = this.holderElement.parentNode;

      if (parentNode) parentNode.removeChild(this.holderElement);
    }

    this.holderElement = null;
  }
}
customElements.define("sfml-badge", Badge);



// WEBPACK FOOTER //
// webpack://SFMLWeb/src/renderer/web-components/badge/index.ts